import './style.css'
import TouchableOpacity from '../../common/TouchableOpacity'
import { startCapture } from '../../helper/capture'
import { Dispatch, SetStateAction } from 'react'
import styles from './style'

interface CaptureButtonProps {
  onRightClick?: () => void
  isCapturing: boolean
  setIsCapturing: Dispatch<SetStateAction<boolean>>
}

function CaptureButton({ onRightClick = () => {}, isCapturing, setIsCapturing }: CaptureButtonProps) {
  return (
    <TouchableOpacity
      onClick={() => {
        startCapture({
          processName: 'ffmpegMain',
          fileName: 'TEST_CAPTURE' + Math.random() * 100000,
          onSuccess: () => {
            setIsCapturing(true)
          },
        })
      }}
      onRightClick={onRightClick}
    >
      <div style={{ ...styles.outer, opacity: isCapturing ? 0.8 : 0.5 }}>
        <div style={styles.middle}>
          <div
            style={{
              ...styles.innerBase,
              backgroundColor: isCapturing ? '#FF0000' : '#737373',
              ...(isCapturing ? styles.innerPulse : {}),
            }}
          ></div>
        </div>
      </div>
    </TouchableOpacity>
  )
}

export default CaptureButton
